import React, {useEffect, useState} from "react";
import {Menu, MenuItem, Slider} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import ExploreIcon from "@material-ui/icons/Explore";
// firebase
import "firebase/firestore";
import "firebase/storage";
import ReactDatePicker from "react-datepicker";
import {Controller, useFieldArray, useForm} from "react-hook-form";
// icons
import {AiOutlineUser} from "react-icons/ai";
//slices
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {db} from "../firebase";
import {gameRequests, ROUTES, softSkillsDataset, SUBDOMAIN_URL} from "../db/models/const";
import {professionScopes} from "../db/datasets/professions";
import {closeDialog, openDialog} from "../slices/dialog";
import {
    selectSelectedAreaId,
    selectSelectedRm,
    selectSelectedRmId,
    storeSelectedArea,
    storeSelectedRmId
} from "../slices/selected";
import {selectUid} from "../slices/auth";
import {Collections} from "../api/collections";
import {uploadFile, uploadFileWithExtension} from "../api/common";
import {
    addCompanyRm,
    addGame,
    deleteCompanyRm,
    editCompanyArea,
    updateCompany,
    updateGame,
    updateRmInfo,
    updateRmSoftSkills
} from "../api/company";
import "./CompanyComponents.scss";
import './Dialog/index.scss';
import EditIcon from "@material-ui/icons/Edit";
import InfoIcon from "@material-ui/icons/Info";
import VideoCallIcon from "@material-ui/icons/VideoCall";
import CloseIcon from "@material-ui/icons/Close";
import ButtonCircle from "./Common/ButtonCircle";
import Button from "./Common/Button";
import {sanitizeUrl} from "../helpers/misc";
import AddIcon from "@material-ui/icons/Add";
import {selectAreas, selectMacroareas, selectRole, selectUser} from "../slices/profile";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import {openAlert} from "../slices/alert";
import {Cookies} from "react-cookie-consent";
import MyBadge from "./Common/Badge";
import {CompanyRmShareTutorial} from "./Dialog/Company/RmShareTutorial";
import {useTranslation} from "react-i18next";
import {AddVideo} from "../pages/CompanyPrivate/components/AddVideo/main";
import {UpdateVideo} from "../pages/CompanyPrivate/components/UpdateVideo/main";
import {VideoFrame} from "./Common/VideoFrame/main";
import {endOfDayAsDate} from "../helpers/time";
import TextEditor from "../common/components/TextEditor/main";

export const CompanyRms = (props) => {
    const areaId = useSelector(selectSelectedAreaId);
    const role = useSelector(selectRole);
    const rms = props.rms;

    const onRmClick = (rmId, areaId) => {
        // const setRmId = {
        // 	type: SELECT_RM,
        // 	payload: {
        // 		rmId,
        // 		areaId
        // 	},
        // };
        // dispatch(setRmId);
        // if (role === "student") history.push("/company/rm");
        // if (role === "company") history.push("/rm");
        // dispatch(storeContent);
    };

    const onRmDelete = (rmId) => {
        if (!rmId) return;
        deleteCompanyRm(rmId, areaId);
    };

    const countStudents = (rm) => {
        return Object.values(rm?.joins || []).length;
    };

    return (
        <div className="companyRms">
            <div
                className="row"
                style={role === "company" ? {paddingTop: "0"} : {paddingTop: "10px"}}
            >
                {rms.map((rm) => (
                    <div key={rm.id} className="card">
                        <div className="card__header">
                            <h2>{rm.name}</h2>
                            <div className="actions">
                                <ButtonCircle onClick={() => onRmClick(rm.id, rm.areaId)}><ExploreIcon/></ButtonCircle>
                                {role === "company" &&
                                    <ButtonCircle onClick={() => onRmDelete(rm.id)}><DeleteIcon/></ButtonCircle>}
                            </div>
                        </div>
                        <div className="card__content">
                            <AiOutlineUser className="icon"/>
                            <p>{countStudents(rm)} Persone</p>
                        </div>
                        <div className="card__footer"></div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export const EditCompanyArea = ({area}) => {
    const dispatch = useDispatch();
    const uid = useSelector(selectUid);
    const user = useSelector(selectUser);
    const macroareas = useSelector(selectMacroareas);
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
            name: area?.name || "",
            macroareaId: area?.macroareaId || ""
        }
    });
    const {t} = useTranslation();
    const [description, setDescription] = useState();

    const onSave = async form => {
        const newArea = {
            ...area,
            name: form.name,
            description,
            macroareaId: form.macroareaId,
            demo: user.demo == null ? false : user.demo
        }
        editCompanyArea(newArea).then((a) => {
            if (form.image.length > 0) {
                const image = form.image[0];
                // const resizedFile = await resizeFile(photo);
                uploadFile(image, `${uid}/areas/${a.id}/image`, "image", `${Collections.COMPANY_AREAS}/${a.id}`);
            }
            dispatch(closeDialog());
        });
    };

    return (
        <div className="addCompanyArea">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("company_addArea_name_label")}</div>
                    <input
                        type="text"
                        placeholder={t("company_addArea_name_ph")}
                        ref={register({required: true})}
                        name="name"
                    ></input>
                    {errors.name && <p>{t("company_addArea_name_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("company_addArea_desc_label")}</div>
                    {/*<textarea*/}
                    {/*    type="text"*/}
                    {/*    placeholder={t("company_addArea_desc_ph")}*/}
                    {/*    ref={register}*/}
                    {/*    name="description"*/}
                    {/*    rows="6"*/}
                    {/*></textarea>*/}
                    <TextEditor
                        editorStyle={{minHeight: "150px"}}
                        placeholder={t("company_addArea_desc_ph")}
                        defaultValue={area?.description || ""}
                        HTMLvalueOnChangeCB={setDescription}/>
                </div>
                <div className="element">
                    <div className="label">{t("company_addArea_macro_label")}</div>
                    <select name="macroareaId" ref={register}>
                        <option key={""} value={""}>{t("company_addArea_macro_none")}</option>
                        {macroareas.map(macro => <option key={macro.id} value={macro.id}>{macro.name}</option>)}
                    </select>
                </div>
                <div className="element">
                    <div className="label">{t("company_addArea_img_label")}</div>
                    <input
                        type="file"
                        accept="image/*"
                        name="image"
                        ref={register}
                    />
                </div>
                <input type="submit" value={t("company_addArea_submit")}></input>
            </form>
        </div>
    );
};

export const AddCompanyRm = ({areaId}) => {
    const dispatch = useDispatch();
    const {register, handleSubmit} = useForm({
        defaultValues: {
            name: ""
        }
    });

    const onSave = async (form) => {
        await addCompanyRm(form.name, areaId);
        dispatch(closeDialog());
    };

    return (
        <>
            <form onSubmit={handleSubmit(onSave)}>
                <div>Aggiungi un nuovo Role Model</div>
                <input
                    type="text"
                    name="name"
                    placeholder="Dai un nome al Role Model"
                    ref={register({required: true})}
                />
                <input type="submit" value="SALVA"/>
            </form>
        </>
    );
};

// export const CompanyCover = () => {
// 	const { company, user: { uid } } = useSelector((store) => store);
// 	const [edit, setEdit] = useState(false);

// 	return (
// 		<div
// 			className="companyCover"
// 			style={{
// 				height: "200px",
// 				backgroundColor: "#234",
// 				backgroundImage: `url(${company?.coverUrl})` || null,
// 				backgroundSize: "cover",
// 				backgroundPosition: "center",
// 				display: "flex",
// 				justifyContent: "center",
// 				alignItems: "center",
// 			}}
// 		>
// 			{edit && (
// 				<FileUploader
// 					storagePath={`${uid}/profile/cover`}
// 					collection={Collections.USERS}
// 					urlField="coverUrl"
// 					setEdit={setEdit}
// 				/>
// 			)}
// 			{!edit && (
// 				<FaEdit
// 					onClick={() => setEdit(!edit)}
// 					style={{
// 						color: "white",
// 						position: "absolute",
// 						right: 20,
// 						bottom: 20,
// 					}}
// 				/>
// 			)}
// 		</div>
// 	);
// };


export const ExploreSoftSkills = ({softSkillsExplanation}) => {
    const {t} = useTranslation();

    return <div className="exploreSoftSkills">
        <p className="pre-wrap">{softSkillsExplanation || t("student_follow_ss_expl_missing")}</p>
    </div>
}

export const CompanySoftSkillsEdit = ({rm}) => {
    const [softSkills, setSoftSkills] = useState();

    const {register, handleSubmit, errors, control, getValues} = useForm({
        defaultValues: {
            softSkills: {
                LEADER: softSkills.LEADER,
                VISIONARY: softSkills.VISIONARY,
                THOUGHTFUL: softSkills.THOUGHTFUL,
                SOFT: softSkills.SOFT,
                FOLLOWER: softSkills.FOLLOWER,
                PRAGMATIC: softSkills.PRAGMATIC,
                IMPULSIVE: softSkills.IMPULSIVE,
                HARD: softSkills.HARD
            },
            softSkillsExplanation: rm?.softSkillsExplanation || ""
        }
    });
    const dispatch = useDispatch();
    const [max, setMax] = useState();
    const [sum, setSum] = useState(Object.values(softSkills).reduce((a, b) => a + b, 0));

    const onValueChange = () => {
        const form = getValues();
        const newSum = Object.values(form.softSkills).reduce((a, b) => a + b, 0);
        setSum(newSum);
    }

    useEffect(() => {
        setMax(50);
    }, [])

    useEffect(() => {
        setSoftSkills(rm?.softSkills ? rm?.softSkills :
            {
                LEADER: 0,
                VISIONARY: 0,
                THOUGHTFUL: 0,
                SOFT: 0,
                FOLLOWER: 0,
                PRAGMATIC: 0,
                IMPULSIVE: 0,
                HARD: 0
            });
    }, [rm]);

    const onSave = (form) => {
        if (sum > max) return;

        updateRmSoftSkills(rm.id, form).then(() => {
            dispatch(closeDialog())
        });
    }

    return (
        <div className="companySoftSkillsEdit">
            <p>{"Somma attuale / Totale punti assegnabili"}</p>
            <p className={sum > max ? "counters error" : "counters"}>{sum}{" / "}{max}</p>
            <form onSubmit={handleSubmit(onSave)}>
                {Object.keys(softSkillsDataset).map(tag => (
                    <div className="element">
                        <label>{softSkillsDataset[tag].label}</label>
                        <Controller
                            name={`softSkills.${tag}`}
                            onChange={(_, data) => data}
                            control={control}
                            rules={{required: true, min: 1}}
                            render={(props) => (
                                <Slider
                                    {...props}
                                    onChange={(_, value) => {
                                        props.onChange(value);
                                        onValueChange(value);
                                    }}
                                    marks={true}
                                    valueLabelDisplay="auto"
                                    min={1}
                                    max={10}
                                    step={1}
                                />
                            )}
                        />
                        {errors[tag] && <span className="error">Campo richiesto</span>}
                    </div>
                ))}
                <>
                    <div className="row">
                        <p>Descrizione delle competenze trasversali</p>
                    </div>
                    <textarea
                        type="text"
                        name="softSkillsExplanation"
                        ref={register()}
                        placeholder="Aggiungi una spiegazione"
                        rows="6"
                    />
                </>
                <input type="submit" value="SALVA"/>
            </form>
        </div>
    );
}

export const RmInfo = ({rm, logoUrl, unfollow, video}) => {
    const role = useSelector(selectRole);
    const dispatch = useDispatch();
    const history = useHistory();
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [highlight, setHighlight] = useState(false);
    const {t} = useTranslation();

    const onEditInfoClick = () => {
        onMenuClose();
        dispatch(openDialog({
            Content: EditRmInfo,
            title: "Percorso Formativo",
            props: {
                rm,
            },
            closable: true
        }));
    };

    const onAddVideoClick = () => {
        onMenuClose();
        dispatch(openDialog({
            Content: AddVideo,
            title: t("rm_info_addVideo"),
            props: {
                rm,
            },
            closable: true
        }));
    }

    const onUpdateVideoClick = () => {
        onMenuClose();
        dispatch(openDialog({
            Content: UpdateVideo,
            title: t("rm_info_updateVideo"),
            props: {
                video,
            },
            closable: true
        }));
    }

    useEffect(() => {
        if (role !== 'company') return;

        const tutorialDone = Cookies.get("shareTutorialDone");
        setHighlight(!tutorialDone);
    }, [role])

    const onLogoClick = () => {
        if (role === "student")
            history.push(ROUTES.COMPANY.replace(":companyId", rm.companyId));
    }

    const onExploreClick = () => {
        onMenuClose();
        dispatch(openDialog({
            Content: ExploreRmInfo,
            title: t("exploreRmInfo_title"),
            props: {
                rm,
            },
            closable: true
        }));
    }

    const onMenuOpen = (event) => {
        setMenuAnchor(event.currentTarget);
    };

    const onMenuClose = () => {
        setMenuAnchor(null);
    };

    const copyRmLink = async () => {
        try {
            onMenuClose();
            await navigator.clipboard.writeText(`${SUBDOMAIN_URL}/public/rm/${rm.id}`);
            dispatch(openAlert({type: "success", message: t("alert_clipboard")}));

            if (highlight) {
                Cookies.set("shareTutorialDone", true, {expires: 1000});
                setHighlight(false);
                dispatch(openDialog({
                    Content: CompanyRmShareTutorial,
                    title: "",
                    props: {},
                    closable: false,
                    narrow: true
                }));
            }
        } catch (error) {
            dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
        }
    }

    const onUnfollow = () => {
        onMenuClose();
        unfollow();
    }

    return (
        <div className="rmInfo">
            {rm?.tag != null ? <p className="rmInfo__tag">#{t(professionScopes[rm.tag].label)}</p> : null}
            <div className="rmInfo__options">
                <ButtonCircle
                    highlight={highlight}
                    negative={!highlight}
                    aria-controls="menu"
                    aria-haspopup="true"
                    onClick={onMenuOpen}
                ><MoreHorizIcon/></ButtonCircle>

                <Menu
                    id="menu"
                    anchorEl={menuAnchor}
                    keepMounted
                    open={Boolean(menuAnchor)}
                    onClose={onMenuClose}
                >
                    {role === "company" &&
                        <MenuItem onClick={onEditInfoClick}><EditIcon/>{t("rm_info_update")}</MenuItem>}
                    {unfollow && <MenuItem onClick={onUnfollow}><CloseIcon/>{t("rm_info_leave")}</MenuItem>}
                    <MenuItem onClick={onExploreClick}><InfoIcon/>{t("rm_info_explore")}</MenuItem>
                    {role === "company" && <MyBadge badgeContent={""} invisible={!highlight}>
                        <MenuItem onClick={copyRmLink}><FileCopyIcon/>{t("rm_info_share")}</MenuItem>
                    </MyBadge>}
                    {role === "company" && !video &&
                        <MenuItem onClick={onAddVideoClick}><VideoCallIcon/>{t("rm_info_addVideo")}</MenuItem>}
                    {role === "company" && video &&
                        <MenuItem onClick={onUpdateVideoClick}><VideoCallIcon/>{t("rm_info_updateVideo")}</MenuItem>}

                </Menu>
                {/* {role === "company" && <ButtonCircle negative={true} onClick={() => onEditInfoClick()}><EditIcon /></ButtonCircle>}
				<ButtonCircle onClick={() => onExploreClick()} negative={true}><InfoIcon /></ButtonCircle> */}
            </div>
            <div className="rmInfo__content">
                {!video && <div className="logo" onClick={() => onLogoClick()}
                                style={{backgroundImage: `url(${logoUrl})` || null}}></div>}
                {video && <VideoFrame height="200px" width="150px" video={video}/>}
                {rm?.name && <div className="name">
                    <h2>{rm.name}</h2>
                </div>}
                {rm?.mission && <p className="mission" dangerouslySetInnerHTML={{__html: rm.mission}} />}
            </div>
        </div>
    );
}

export const ExploreRmInfo = ({rm}) => {
    const duties = rm?.duties || "";
    const careers = rm?.careers || "";
    const link = rm?.link || "";
    const mission = rm?.mission || "";
    const {t} = useTranslation();

    return <div className="exploreRmInfo">
        {mission && <>
            <label>{t("exploreRmInfo_mission")}</label>
            <div dangerouslySetInnerHTML={{__html: mission}} />
        </>}
        {duties && <>
            <label>{t("exploreRmInfo_duties")}</label>
            <div dangerouslySetInnerHTML={{__html: duties}} />
        </>}
        {careers && <>
            <label>{t("exploreRmInfo_careers")}</label>
            <div dangerouslySetInnerHTML={{__html: careers}} />
        </>}
        {link && <>
            <label>Link</label><br/>
            <a className="link" target="_blank" rel="noopener noreferrer" href={sanitizeUrl(link)}>{link}</a>
        </>}
    </div>
}

// export const CompanyRmStudents = () => {
// 	const areaId = useSelector((store) => store.areaId);
// 	const areas = useSelector((store) => store.areas);
// 	const rmId = useSelector((store) => store.rmId);
// 	const [students, setStudents] = useState([]);

// 	useEffect(() => {
// 		if (!areas || !areaId || !rmId) return;
// 		const vals =
// 			Object.values(
// 				areas.find((area) => area.id === areaId).rms[rmId]?.joins || {}
// 			).map((join) => join.studentId) || [];

// 			getFollowers(vals).then((s) => {
// 			setStudents(s);
// 		});
// 	}, [areas, areaId, rmId]);

// 	return (
// 		<div className="companyRmStudents">
// 			<nav>
// 				<div className="title">Talenti</div>
// 			</nav>
// 			{students.length > 0 && (
// 				<div className="card-grid card-grid-4" style={{ padding: "0 10px" }}>
// 					{students.map((student) => (
// 						<div key={student?.info?.uid} className="card">
// 							<div className="avatar">
// 								<div
// 									className="avatar__image"
// 									style={{
// 										backgroundImage: `url(${student?.info?.photoUrl})` || null,
// 									}}
// 								></div>
// 								<div className="title">
// 									{student?.info?.name?.replace("_", " ")}
// 								</div>
// 							</div>
// 						</div>
// 					))}
// 				</div>
// 			)}
// 			{students.length === 0 && (
// 				<div style={{ padding: "0 10px" }}>Nessun Talento</div>
// 			)}
// 			<nav></nav>
// 		</div>
// 	);
// };

export const EditRmInfo = ({rm, areaId}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector(selectUser);
    const areas = useSelector(selectAreas);
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
            name: rm?.name,
            tag: rm?.tag,
            link: sanitizeUrl(rm?.link),
            coming: rm?.coming === undefined ? true : rm.coming
        }
    });
    const [mission, setMission] = useState(rm?.mission || "");
    const [duties, setDuties] = useState(rm?.duties || "");
    const [careers, setCareers] = useState(rm?.careers || "");

    const onSubmit = (form) => {
        form.tag = Number(form.tag);
        form.mission = mission;
        form.duties = duties;
        form.careers = careers;

        if (form?.coming === undefined) form.coming = true;

        if (!rm) {
            // new Role Model
            form.demo = user?.demo ? true : false;

            addCompanyRm(form, areaId).then(
                (rmId) => {
                    dispatch(closeDialog());
                    dispatch(storeSelectedRmId({rmId}));

                    const area = areas.find(area => area.id === areaId);
                    dispatch(storeSelectedArea({area}));
                    history.push(ROUTES.COMPANY_RM);
                }
            );
        } else {
            // update Role Model
            updateRmInfo(rm.id, rm.areaId, form).then(
                () => {
                    dispatch(closeDialog());
                }
            );
        }
    };
    return (
        <div className="editRmInfo bg-dialog">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="element">
                    <div className="label">{t("company_addRm_name_label")}</div>
                    <input
                        type="text"
                        name="name"
                        placeholder={t("company_addRm_name_ph")}
                        ref={register({required: true})}
                    ></input>
                    {errors.name && <p>{t("company_addRm_name_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("company_addRm_scope_label")}</div>
                    <select
                        name="tag"
                        ref={register({required: true})}
                    >
                        {professionScopes.map((item, index) => (
                            <option value={item.id} key={item.id}>
                                {t(item.label)}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="element">
                    <div className="label">{t("company_addRm_mission_label")}</div>
                    {/*<textarea*/}
                    {/*    name="mission"*/}
                    {/*    placeholder={t("company_addRm_mission_ph")}*/}
                    {/*    rows="10"*/}
                    {/*    ref={register}*/}
                    {/*></textarea>*/}
                    <TextEditor
                        editorStyle={{minHeight: "150px"}}
                        placeholder={t("company_addRm_mission_ph")}
                        defaultValue={mission}
                        HTMLvalueOnChangeCB={setMission}/>
                </div>
                <div className="element">
                    <div className="label">{t("company_addRm_duties_label")}</div>
                    <TextEditor
                        editorStyle={{minHeight: "150px"}}
                        placeholder={t("company_addRm_duties_ph")}
                        defaultValue={duties}
                        HTMLvalueOnChangeCB={setDuties}/>
                </div>
                <div className="element">
                    <div className="label">{t("company_addRm_careers_label")}</div>
                    <TextEditor
                        editorStyle={{minHeight: "150px"}}
                        placeholder={t("company_addRm_careers_ph")}
                        defaultValue={careers}
                        HTMLvalueOnChangeCB={setCareers}/>
                </div>
                <div className="element">
                    <div className="label">{t("company_addRm_link_label")}</div>
                    <input
                        type="text"
                        name="link"
                        placeholder={t("company_addRm_link_ph")}
                        ref={register}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("company_addRm_coming_label")}</div>
                    {user?.rmTerms &&
                        <div className="checkbox">
                            <input type="checkbox" name="coming" ref={register}></input>
                            <p>{t("company_addRm_coming_text")}</p>
                        </div>
                    }
                    {!(user?.rmTerms) && <p className="error">{t("company_addRm_missingPolicy")}</p>}
                </div>
                <input type="submit" value={t("company_addRm_submit")}/>
            </form>
        </div>
    );
};

export const EditGame = ({game}) => {
    const dispatch = useDispatch();
    const uid = useSelector(selectUid);
    const rmId = useSelector(selectSelectedRmId);
    const rm = useSelector(selectSelectedRm);
    const groups = Object.values(rm?.groups || {}).sort((a, b) => {
        if (a.name < b.name) return -1;
        else if (a.name > b.name) return 1;
        else return 0;
    });
    const attachmentCount = Object.values(game?.attachments || {}).length;
    const {t} = useTranslation();
    const [showDeadline, setShowDeadline] = useState(true);
    const {register, handleSubmit, errors, control, setError} = useForm({
        defaultValues: {
            title: game?.title || "",
            target: game?.target || "",
            description: game?.description || "",
            task: game?.task,
            request: game?.request || "",
            reward: game?.reward,
            link: game?.link || "",
            deadline: game?.deadline ? new Date(game.deadline.seconds * 1000) : null,
            durationDays: game?.durationDays
        }
    });

    const onSubmit = async (form) => {
        if (!rmId)
            return;

        if (showDeadline && !form?.deadline) {
            setError("deadline");
            return;
        }
        if (!showDeadline && !form?.durationDays) {
            setError("durationDays");
            return;
        }

        const g = {
            id: game?.id || db.collection(Collections.GAMES).doc().id,
            companyId: uid,
            rmId,
            title: form.title,
            target: form.target,
            description: form.description,
            task: form.task,
            request: form.request,
            reward: form.reward,
            deadline: showDeadline ? endOfDayAsDate(form.deadline) : null,
            durationDays: !showDeadline ? Number(form.durationDays) : 0,
            link: form.link,
            attachments: game?.attachments || {},
            notifiedAt: game?.notifiedAt || new Date(0),
            state: "ACTIVE",
            created: game?.created || new Date()
        };

        if (game?.id)
            await updateGame(g);
        else
            await addGame(g);

        if (form.attachment_1 && form.attachment_1.length > 0) {
            const file = form.attachment_1[0];
            uploadFileWithExtension(file, `${uid}/games/${g.id}/attachments/${file.name}`, ["attachments", file.name], `${Collections.GAMES}/${g.id}`);
        }
        if (form.attachment_2 && form.attachment_2.length > 0) {
            const file = form.attachment_2[0];
            uploadFileWithExtension(file, `${uid}/games/${g.id}/attachments/${file.name}`, ["attachments", file.name], `${Collections.GAMES}/${g.id}`);
        }

        dispatch(closeDialog());
    };

    useEffect(() => {
        setShowDeadline(game?.deadline ? true : false);
    }, [game])

    return (
        <div className="bg-dialog editGame">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="element">
                    <div className="label">{t("company_rm_editGame_name_label")}</div>
                    <input name="title" placeholder={t("company_rm_editGame_name_ph")} type="text"
                           ref={register({required: true})}></input>
                    {errors.title && <span className="error">{t("company_rm_editGame_name_error")}</span>}
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editGame_target_label")}</div>
                    <select name="target" ref={register}>
                        <option key={""} value={""}>{t("company_rm_editGame_target_all")}</option>
                        {groups.map(group => <option key={group.id} value={group.id}>{group.name}</option>)}
                    </select>
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editGame_desc_label")}</div>
                    <textarea
                        rows="6"
                        name="description"
                        placeholder={t("company_rm_editGame_desc_ph")}
                        ref={register({required: true})}
                    ></textarea>
                    {errors.description && <span className="error">{t("company_rm_editGame_desc_error")}</span>}
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editGame_task_label")}</div>
                    <textarea
                        rows="6"
                        name="task"
                        maxLength={400}
                        placeholder={t("company_rm_editGame_task_ph")}
                        ref={register({required: true})}
                    ></textarea>
                    {errors.task && <span className="error">{t("company_rm_editGame_task_error")}</span>}
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editGame_request_label")}</div>
                    <select name="request" ref={register({required: true})}>
                        {gameRequests.map(request => <option value={request.id}>{t(request.label)}</option>)}
                    </select>
                    {errors.request && <span className="error">{t("company_rm_editGame_request_error")}</span>}
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editGame_reward_label")}</div>
                    <textarea
                        rows="4"
                        name="reward"
                        maxLength={300}
                        placeholder={t("company_rm_editGame_reward_ph")}
                        ref={register}/>
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editGame_link_label")}</div>
                    <input name="link" placeholder={t("company_rm_editGame_link_ph")} type="text"
                           ref={register({required: false})}/>
                </div>
                <div className="editGame__duration">
                    <div className="editGame__durationTitle">{t("company_rm_editGame_duration_title")}</div>
                    <div className="editGame__durationCheckbox">
                        <input type="checkbox" checked={showDeadline} onChange={e => setShowDeadline(!showDeadline)}/>
                        <p>{t("company_rm_editGame_duration_checkbox_deadline")}</p>
                    </div>
                    <div className="editGame__durationCheckbox" style={{marginBottom: "5px"}}>
                        <input type="checkbox" checked={!showDeadline} onChange={e => setShowDeadline(!showDeadline)}/>
                        <p>{t("company_rm_editGame_duration_checkbox_durationDays")}</p>
                    </div>

                    {showDeadline && <div className="element">
                        <div className="label">{t("company_rm_editGame_deadline_label")}</div>
                        <Controller
                            control={control}
                            rules={{required: true}}
                            name="deadline"
                            render={({onChange, onBlur, value}) => (
                                <ReactDatePicker
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    selected={value}
                                    dateFormat="dd/MM/yyyy"
                                />
                            )}
                        />
                        {errors.deadline && <span className="error">{t("company_rm_editGame_deadline_error")}</span>}
                    </div>}
                    {!showDeadline && <div className="element">
                        <div className="label">{t("company_rm_editGame_durationDays_label")}</div>
                        <input name="durationDays" type="number" ref={register}/>
                        {errors.durationDays &&
                            <span className="error">{t("company_rm_editGame_durationDays_error")}</span>}
                    </div>}
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editGame_attachments_label")}</div>
                    {attachmentCount === 0 && <>
                        <p>{t("company_rm_editGame_attachments_choose_label")}</p>
                        <input type="file" name="attachment_1" accept=".png, .jpg, .jpeg, .pdf" ref={register}/>
                    </>}
                    {attachmentCount < 2 && <>
                        <p>{t("company_rm_editGame_attachments_choose_label")}</p>
                        <input type="file" name="attachment_2" accept=".png, .jpg, .jpeg, .pdf" ref={register}/>
                    </>}
                    {attachmentCount < 2 && <p>{t("company_rm_editGame_attachments_ext")}</p>}
                    {attachmentCount === 2 && <p>{t("company_rm_editGame_attachments_warn")}</p>}
                </div>
                <input type="submit" value={t("company_rm_editGame_attachments_submit")}/>
            </form>
        </div>
    );
};

export const EditCompanySection = ({company, sectionId}) => {
    const uid = useSelector(selectUid);
    const [textEditorVal, setTextEditorVal] = useState()

    const {register, handleSubmit, errors, control} = useForm({
        defaultValues: {
            title: company[sectionId]?.title || "",
            text: company[sectionId]?.text || ""
        }
    });
    const {fields, append, remove} = useFieldArray({
        control,
        name: "files"
    });
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onSubmit = (form) => {
        const section = {
            ...company[sectionId],
            title: form.title,
            text: textEditorVal
        };
        updateCompany({[sectionId]: section}).then(async () => {
            (form?.files || []).map(async i => {
                const file = i.file[0];
                const id = Math.random().toString(36).substr(2, 9);
                const mime = file.type;
                const type = mime.split("/")[0];
                let mediaPathName;
                if (type === "image") mediaPathName = "images";
                else if (type === "video") mediaPathName = "videos";
                else return;

                // const resizedFile = await resizeFile(image);
                uploadFile(file, `${uid}/profile/${mediaPathName}/${id}`, `${sectionId}.${mediaPathName}.${id}`, `${Collections.USERS}/${uid}`);
            })
            dispatch(closeDialog());
        });
    }

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="element">
                    <div className="label">{t("company_editSection_name_label")}</div>
                    <input
                        type="text"
                        placeholder={t("company_editSection_name_ph")}
                        name="title"
                        ref={register}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("company_editSection_text_label")}</div>
                    {/*<textarea*/}
                    {/*    type="text"*/}
                    {/*    name="text"*/}
                    {/*    placeholder={t("company_editSection_text_ph")}*/}
                    {/*    ref={register}*/}
                    {/*    rows="8"/>*/}

                    {/* new rich text editor*/}
                    <TextEditor
                        editorStyle={{minHeight: "150px"}}
                        placeholder={t("company_editSection_text_ph")}
                        defaultValue={company[sectionId]?.text || ""}
                        HTMLvalueOnChangeCB={setTextEditorVal}/>
                </div>
                <div className="element">
                    <div className="label">{t("company_editSection_files_label")}</div>
                    {fields.map((item, index) => (
                        <div key={item.id}>
                            <input
                                type="file"
                                accept="image/*, video/*"
                                name={`files.${index}.file`}
                                ref={register({required: true})}
                                defaultValue={item.file}
                            />
                            <button type="button"
                                    onClick={() => remove(index)}>{t("company_editSection_file_remove")}</button>
                        </div>
                    ))}
                    {errors.files && <p>{t("company_editSection_file_error")}</p>}
                    <Button
                        type="button"
                        onClick={() => append({file: null})}
                    >
                        <AddIcon/>
                        <div className="text">{t("company_editSection_file_add")}</div>
                    </Button>
                </div>
                <input type="submit" value={t("company_editSection_submit")}/>
            </form>
        </div>
    )
}